import { RouteRecordRaw } from 'vue-router';
import dashboardRoutes from '../app/dashboard/dashboard-routes';
import timesheetRoutes from '../app/timesheet/timesheet-routes';
import projectRoutes from '../app/project/project-routes';
import trafficRoutes from '../app/traffic/traffic-routes';
import inboxRoutes from '../app/inbox/inbox-routes';
import staticRoutes from '../app/_static/static-router';
import myTasksRoutes from '../app/my-tasks/my-tasks-routes';
import partnerRoutes from '../app/partner/partner-routes';
import teamRoutes from '../app/team/team-routes';
import reportRoutes from '../app/report/report-routes';
import invoiceRoutes from '../app/invoice/invoice-routes';
import holidayRoutes from '../app/holiday/holiday-routes';
import roleRoutes from '../app/role/role-routes';
import taskRoutes from '../app/project-task/task-routes';
import ideaRoutes from '../app/idea-voter/idea-routes';
import humanResourceRoutes from '../app/human-resource/human-resource-routes';
import cashFlowRoutes from '../app/cash-flow/routes';
import incomeGoalRoutes from '../app/income-goal/income-goal-routes';
import documentsRoutes from '../app/Documents/document-routes';

const appRoutes: Array<RouteRecordRaw> = [
  {
    path: '',
    component: () =>
      import('@/app/shared/components/layouts/app-layout-component.vue'),
    children: [
      // app routes here
      ...dashboardRoutes,
      ...projectRoutes,
      ...timesheetRoutes,
      ...trafficRoutes,
      ...inboxRoutes,
      ...staticRoutes,
      ...myTasksRoutes,
      ...partnerRoutes,
      ...teamRoutes,
      ...holidayRoutes,
      ...reportRoutes,
      ...invoiceRoutes,
      ...roleRoutes,
      ...taskRoutes,
      ...ideaRoutes,
      ...humanResourceRoutes,
      ...incomeGoalRoutes,
      ...documentsRoutes,
      ...cashFlowRoutes,
    ],
  },
];

export default appRoutes;
